export default "<p>logevent works!</p>\n";